export default "__VITE_ASSET__CrpmVKSO__"